<template>
	<div>
		<v-row no-gutters>
			<v-col cols="12" sm="6">
				<v-text-field
					type="text"
					v-model="mailInfo.to"
					:rules="[rules.required]"
					label="TO"
					dense
					outlined
					hide-details="false"
					:class="{ 'custom-disabled-text-color': !!mailAddress, 'mr-2': !$vuetify.breakpoint.xs }"
					:disabled="!!mailAddress"
				/>
			</v-col>
			<v-col cols="12" sm="6">
				<v-combobox
					type="text"
					v-model="mailInfo.cc"
					label="CC"
					:class="$vuetify.breakpoint.xs ? 'mt-4' : ''"
					dense
					outlined
					hide-details="false"
					multiple
					small-chips
				/>
			</v-col>
		</v-row>

		<v-text-field
			type="text"
			v-model="mailInfo.title"
			label="メールタイトル(必須)"
			class="mt-4"
			:rules="[rules.required]"
			dense
			outlined
			hide-details="auto"
		/>
		<v-textarea
			v-model="mailInfo.content"
			label="メール文章(必須)"
			class="mt-4"
			:rules="[rules.required]"
			outlined
			dense
			hide-details="auto"
		/>
	</div>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		mailInfo: {
			title: {
				type: String,
				default: "",
			},
			content: {
				type: String,
				default: "",
			},
			to: {
				type: String,
				default: "",
			},
			cc: {
				type: String,
				default: "",
			},
		},
		mailAddress: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			rules,
		}
	},
}
</script>

<style lang="scss">
@import "../../../stylesheet/global.scss";
</style>
